import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import isObject from "lodash/isObject";
import isUndefined from "lodash/isUndefined";
import mergeWith from "lodash/mergeWith";
import omitBy from "lodash/omitBy";
import values from "lodash/values";

export const hasEmptyValuesDeep = (value?: any, isNested = false): boolean => {
  if (isObject(value)) {
    return isEmpty(value) || values(value).every((value) => hasEmptyValuesDeep(value, true));
  }

  if (!isNested || isArray(value)) {
    return isEmpty(value);
  }

  return value === "" || isNil(value);
};

export const compactObject = <T extends Record<string, any>, U extends T = T>(object: T): U =>
  omitBy(object, isNil) as U;

export const omitUndefined = <T extends Record<string, any>, U extends T = T>(object: T): U =>
  omitBy(object, isUndefined) as U;

export const omitFalsy = <T extends Record<string, any>, U extends T = T>(object: T): U =>
  omitBy(object, (value) => !value) as U;

export const mergeOverwritingArrays = <T extends Record<string, any>>(
  oldValues: T,
  ...updatedValuesChunks: Partial<T>[]
) =>
  updatedValuesChunks.reduce(
    (finalValues, updatedValuesChunk) =>
      mergeWith<T, Partial<T>>(finalValues as T, updatedValuesChunk, (oldValue, updatedValue) =>
        isArray(updatedValue) ? updatedValue : undefined
      ),
    oldValues
  ) as T;

export const getMergedOverwritingArrays = <T extends Record<string, any>>(
  oldValues: T,
  ...updatedValuesChunks: Partial<T>[]
) => mergeOverwritingArrays({} as T, oldValues, ...updatedValuesChunks);
